import { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import LandingLayout from "./LandingLayoutRedesign";
import ExternalUserDashboard from "../Dashboard/ExternalUserDashboard";
import "./LandingDashboardPage.css";

const LandingDashboardPage = () => {
  const { isDark } = useContext(ThemeContext);

  return (
    <LandingLayout>
      <div className={`landing-dashboard-page${isDark ? " landing-dashboard-page--dark" : ""}`}>
        <div className="landing-dashboard-inner">
          <ExternalUserDashboard />
        </div>
      </div>
    </LandingLayout>
  );
};

export default LandingDashboardPage;
